'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Check = require('./Check');

var _Check2 = _interopRequireDefault(_Check);

var _HourGlass = require('./HourGlass');

var _HourGlass2 = _interopRequireDefault(_HourGlass);

var _Stop = require('./Stop');

var _Stop2 = _interopRequireDefault(_Stop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Highlight = function (_React$Component) {
  _inherits(Highlight, _React$Component);

  function Highlight() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Highlight);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Highlight.__proto__ || Object.getPrototypeOf(Highlight)).call.apply(_ref, [this].concat(args))), _this), _this.renderIcon = function () {
      var _this$props = _this.props,
          size = _this$props.size,
          colorIcon = _this$props.colorIcon,
          type = _this$props.type;


      if (type === 'play') {
        return _react2.default.createElement(
          'svg',
          {
            width: size > 20 ? size - 20 : 6,
            height: size > 20 ? size - 20 : 10,
            viewBox: '0 0 6 10',
            version: '1.1',
            xmlnsXlink: 'http://www.w3.org/1999/xlink',
            style: {
              marginLeft: size > 20 ? '5%' : 0
            }
          },
          _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', { d: 'M8 5.517v8.966a.62.62 0 0 0 .072.292c.127.236.382.296.568.134l5.182-4.483a.472.472 0 0 0 .106-.134c.128-.236.08-.558-.106-.719L8.64 5.09A.352.352 0 0 0 8.41 5c-.227 0-.41.231-.41.517z' })
          ),
          _react2.default.createElement(
            'g',
            {
              transform: 'translate(-7.5, -5.000000)',
              stroke: 'none',
              strokeWidth: 1,
              fill: 'none',
              fillRule: 'evenodd'
            },
            _react2.default.createElement('path', {
              d: 'M8 5.517v8.966a.62.62 0 0 0 .072.292c.127.236.382.296.568.134l5.182-4.483a.472.472 0 0 0 .106-.134c.128-.236.08-.558-.106-.719L8.64 5.09A.352.352 0 0 0 8.41 5c-.227 0-.41.231-.41.517z',
              fill: '#FFF'
            })
          )
        );
      }

      if (type === 'check') {
        return _react2.default.createElement(_Check2.default, { size: size > 20 ? size - 20 : 10 });
      }

      if (type === 'hourGlass') {
        return _react2.default.createElement(_HourGlass2.default, { size: size > 20 ? size - 20 : 10, color: '#fff' });
      }

      if (type === 'stop') {
        return _react2.default.createElement(_Stop2.default, { size: size > 20 ? size - 20 : 10, color: '#fff' });
      }

      return _react2.default.createElement(
        'svg',
        {
          width: size > 20 ? size - 15 : 4,
          height: size > 20 ? size - 15 : 12,
          viewBox: '0 0 4 12',
          version: '1.1',
          xmlnsXlink: 'http://www.w3.org/1999/xlink'
        },
        _react2.default.createElement('path', {
          d: 'M2 0a2 2 0 0 1 2 2v3a2 2 0 1 1-4 0V2a2 2 0 0 1 2-2zm0 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4z',
          fill: colorIcon,
          fillRule: 'evenodd'
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Highlight, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          color = _props.color;

      return _react2.default.createElement(
        'div',
        {
          style: {
            width: size,
            height: size,
            background: color
          },
          className: 'jsx-1698642149' + ' ' + 'circle'
        },
        this.renderIcon(),
        _react2.default.createElement(
          _style2.default,
          {
            id: '1698642149'
          },
          ['.circle.jsx-1698642149{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:50%;}']
        )
      );
    }
  }]);

  return Highlight;
}(_react2.default.Component);

Highlight.defaultProps = {
  size: 20,
  color: '#00B083',
  colorIcon: '#FFFFFF',
  type: 'exclamation'
};

Highlight.propTypes = {
  size: _propTypes2.default.number,
  type: _propTypes2.default.oneOf(['check', 'play', 'exclamation']),
  color: _propTypes2.default.string,
  colorIcon: _propTypes2.default.string
};

exports.default = Highlight;